export default {
    computed: {
        ui() {
            return this.$store.state.ui;
        },

        isTouchDevice() {
            return this.ui.isTouch;
        },
    },

    methods: {
        isDevice(name) {
            return name === this.ui.device;
        }
    }
}